import script from "./rec-rich-text.vue?vue&type=script&lang=ts&setup=true"
export * from "./rec-rich-text.vue?vue&type=script&lang=ts&setup=true"

import "./rec-rich-text.vue?vue&type=style&index=0&id=1385d687&lang=scss"

const __exports__ = script;

export default __exports__